export default __webpack_public_path__ + "static/media/Ring of the Astral Step.e45b8f86.jpg";